import Swiper from 'swiper';

export default class Carousel {
    constructor(carouselEl) {
        new Swiper(carouselEl, {
            slidesPerView: 1,
            initialSlide: 2,
            centeredSlides: true,
            spaceBetween: 30,
            freeMode: true,
            loop: true,
            autoplay: {
                delay: 5000,
            },
        });
    }
}